
import { Modal  } from 'uiv'

export const modal = () => {
    return {
      data() {
        return {
          modalShow:false,
          modalLink:'',
          modalBool:false,
        }
      },
      methods: {
        modalhide() {
          setTimeout(() => {
            this.modalShow = false
          },1200)
        },
        toModalLink() {
          if (this.modalLink) {
            this.$router.push({
              path: this.modalLink
            });
          }
        }
      },
      watch: {
        modalShow(curVal, oldVal) {
          if (curVal && !this.modalLink) {
            this.modalhide()
          }
        }
      },
      components: {
        Modal
      }
    }
  }


// WEBPACK FOOTER //
// ./src/common/mixin/modal.js